<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
   sodipodi:docname="tongue_S_round_4.svg"
   id="svg1118"
   version="1.1"
   viewBox="0 0 360 400"
   :height="height"
   :width="width">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     inkscape:window-maximized="0"
     inkscape:window-y="23"
     inkscape:window-x="0"
     inkscape:window-height="755"
     inkscape:window-width="1252"
     scale-x="1"
     units="px"
     showgrid="false"
     inkscape:document-rotation="0"
     inkscape:current-layer="layer1"
     inkscape:document-units="px"
     inkscape:cy="187.25371"
     inkscape:cx="196.45427"
     inkscape:zoom="0.98994949"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     borderopacity="1.0"
     bordercolor="#666666"
     pagecolor="#ffffff"
     id="base" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
   <path
       id="outside"
       style="fill:#ff000000;stroke:#ffffff;stroke-width:0.917065;stroke-opacity:1"
       d="M 0 0 L 0 400 L 55.558594 400 L 55.558594 399.54102 L 332.04102 399.54102 L 332.04102 399.5 L 360.62305 399.5 L 360.62305 0.5 L 332.04102 0.5 L 332.04102 0.45898438 L 55.558594 0.45898438 L 55.558594 0 L 0 0 z M 225.70703 22.044922 C 237.19017 21.838054 248.52881 30.202356 262.50195 62.455078 C 300.25356 149.59313 265.96006 376.93654 179.67578 377.95508 C 92.528966 373.88092 60.205408 149.16575 97.658203 61.900391 C 126.66979 -5.6968666 149.22824 33.378681 182.05273 33.472656 C 199.49074 33.522576 212.6928 22.279373 225.70703 22.044922 z " />
   <path
       id="mouth"
       style="fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       d="M 180 8.7871094 C 117.76101 8.7872428 67.307033 23.06088 67.308594 40.667969 C 67.309694 46.932323 86.086495 57.788233 98.320312 63.009766 C 127.09882 -4.044429 149.47632 34.717328 182.03711 34.810547 C 214.5979 34.903767 232.268 -4.6944417 261.83789 63.558594 C 262.16871 64.322191 262.4811 65.121196 262.80078 65.90625 C 275.08138 60.337811 292.69073 46.769471 292.69141 40.667969 C 292.69297 23.06088 242.23899 8.7872422 180 8.7871094 z " />
  <g id="cover_layer">
   <path
       style="display:inline;fill:none;stroke:#ff000000;stroke-width:1.75007px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       d="M 107.52746,58.441137 C 74.563769,135.24685 103.01392,333.0283 179.7153,336.61413 255.65752,335.71767 285.83932,135.62318 252.61262,58.929528 226.37621,-1.6291994 210.69784,33.503794 181.8077,33.421083 152.91755,33.338373 133.06171,-1.0538975 107.52746,58.441137 Z"
       id="cover"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="scsss" />
  </g>
  <g
     id="body_layer"
     inkscape:groupmode="layer"
     inkscape:label="Layer 1">
    <path
       sodipodi:nodetypes="scsss"
       inkscape:connector-curvature="0"
       id="body"
       d="M 98.319393,63.008994 C 61.167486,149.57328 93.232375,372.48392 179.67907,376.52534 265.27016,375.51498 299.28672,149.99743 261.83839,63.559438 232.2685,-4.6935974 214.59811,34.903229 182.03732,34.810009 149.47653,34.71679 127.0979,-4.0452006 98.319393,63.008994 Z"
       style="display:inline;fill:#f59a9a;stroke:#ff000000;stroke-width:1.97243px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       d="m 180.45365,280.76136 c -23.03673,-0.0659 -45.92795,8.90244 -70.10566,28.28101 5.81868,13.86927 12.53975,26.27008 20.13488,36.54633 36.63598,-15.49388 69.4524,-14.23728 99.39397,-0.36921 7.90759,-10.92441 14.87074,-24.23032 20.85453,-39.11715 -24.50303,-16.36413 -47.46438,-25.27488 -70.27772,-25.34098 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lg"
       inkscape:connector-curvature="0" />
    <path
       inkscape:connector-curvature="0"
       d="m 182.81108,334.1333 c -16.64924,-0.21066 -34.15297,3.32008 -52.62268,11.094 13.68934,18.66882 30.2349,30.41723 49.47613,31.31676 19.49051,-0.23006 36.30546,-12.10424 50.21231,-31.32457 -14.93445,-7.00337 -30.58211,-10.87762 -47.06576,-11.08619 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="he" />
    <path
       d="M 225.34067,23.473937 C 212.43099,23.706505 199.33477,34.859696 182.03685,34.810173 149.47607,34.716955 127.09783,-4.0450606 98.319325,63.009134 95.247142,70.16736 92.65807,78.273895 90.524112,87.095952 160.6095,102.12187 216.76276,97.021701 269.50474,86.990462 267.40451,78.406933 264.85689,70.526914 261.83856,63.560026 247.97767,31.566415 236.73155,23.268731 225.34067,23.473937 Z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="k-bl-li"
       inkscape:connector-curvature="0" />
    <path
       d="m 269.57422,87.291302 -32.76241,5.237369 c 11.65127,76.240639 8.32601,139.021229 -0.87183,204.319879 l 14.70702,9.45891 c 11.78508,-29.24606 19.77029,-64.63123 23.62222,-100.1781 1.64396,-20.69348 2.34826,-41.47832 2.45007,-61.21529 -0.67553,-20.99734 -3.02953,-40.68602 -7.14507,-57.622768 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lv-gb-l"
       inkscape:connector-curvature="0" />
    <path
       d="m 90.469519,87.330373 c -3.820785,15.879467 -6.144931,34.104227 -7.011063,53.532107 -0.02731,22.20724 0.680209,45.81732 2.617154,69.20517 4.056744,35.21116 12.178469,70.02187 24.13672,98.64264 l 13.42326,-10.04106 C 115.05827,229.16439 112.42213,165.1459 122.40311,92.901792 Z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lv-gb-r"
       inkscape:connector-curvature="0" />
    <path
       id="st-sp"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.708228;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 123.63782,298.67044 c -8.57732,-69.50475 -11.2137,-133.5262 -1.23272,-205.770316 42.25648,5.560681 79.46895,4.170294 114.41082,-0.346332 11.64612,76.227938 8.32104,139.004258 -0.87563,204.294888 -42.94166,-23.10393 -73.0933,-20.60052 -112.30247,1.82145 z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="cccccc" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>